import React from 'react'
import { SlIcon } from '@shoelace-style/shoelace/dist/react'
import StyledNetworkItem from '../styles'

const GeckoTerminal: React.FC = () => (
  <StyledNetworkItem href="https://www.geckoterminal.com/bsc/nomiswap/pools" target="_blank" rel="noreferrer noopener">
    <SlIcon library="social" name="geckoterminal" />
  </StyledNetworkItem>
)

export default GeckoTerminal
